/*
 * The shop sells through two companies, chosen by the payment method:
 * - cash on delivery (pouzećem): BPB 013
 * - card (Banca Intesa e-commerce contract): Vladan Novaković PR Bojenje po brojevima
 * Keep in sync with Merchant.Cod.* / Merchant.Card.* in API/BPB/Web.config (receipts and emails).
 */

export interface ISeller {
  /** Short name used in tight UI (checkout, menu, receipts). */
  name: string;
  /** Full legal name as registered in APR (terms page, EPM 2.1.1). */
  fullName: string;
  /** Registered activity: code and description. */
  activity: string;
  address: string;
  pib: string;
  mb: string;
  vatStatement: string;
}

export const SELLER_COD: ISeller = {
  name: "BPB 013",
  fullName:
    "BRANKICA NOVAKOVIĆ PR TRGOVINA POSREDSTVOM POŠTE ILI INTERNETA BPB 013 VRŠAC",
  activity: "4791 - Trgovina na malo posredstvom pošte ili preko interneta",
  address: "Skadarska 79, 26300 Vršac",
  pib: "114075822",
  mb: "67306147",
  vatStatement: "BPB 013 nije u sistemu PDV-a.",
};

export const SELLER_CARD: ISeller = {
  name: "Vladan Novaković PR Bojenje po brojevima",
  fullName:
    "VLADAN NOVAKOVIĆ PR TRGOVINA NA MALO POSREDSTVOM POŠTE ILI INTERNETA BOJENJE PO BROJEVIMA VRŠAC",
  activity: "4791 - Trgovina na malo posredstvom pošte ili preko interneta",
  address: "Vojnički trg 25/19, 26300 Vršac",
  pib: "111784831",
  mb: "65661985",
  vatStatement: "Vladan Novaković PR Bojenje po brojevima nije u sistemu PDV-a.",
};

export const SHOP_PHONE = "062/8299831";
export const SHOP_EMAIL = "bojenjepobrojevima@gmail.com";
